import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    margin-top: ${rem(MOBILE_HEADER_HEIGHT)};
    padding: 0 ${rem(10)};
    display: flex;
    flex-direction: column;
    gap: ${rem(20)};
    align-items: center;

    @media (min-width: ${breakpoints.xs}px) {
        margin-top: ${rem(DESKTOP_HEADER_HEIGHT)};
    }
`;

export const Title = styled.div`
    display: block;
    padding-bottom: ${rem(8)};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
`;

export const Result = styled.div`
    text-align: center;
    padding: ${rem(45)} 0;
`;

export const SuccessIcon = styled(IconTemplate)`
    svg {
        path {
            fill: ${({ theme }) => theme.colors.primary};
            stroke: ${({ theme }) => theme.colors.primary};
        }
    }
`;

export const SuccessMessage = styled.p`
    text-align: center;

    a {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        color: ${({ theme }) => theme.colors.primary};
        cursor: pointer;
    }
`;

export const Label = styled.span`
    display: block;
    padding-bottom: ${rem(8)};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.textBase};
    position: relative;
`;

export const InputSection = styled.div`
    position: relative;
    margin: 0 auto;
`;

export const Input = styled.input<{ marginBottom?: number }>`
    height: ${rem(45)};
    padding: ${rem(5)} ${rem(15)};
    border: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
    width: ${rem(300)};
    border-radius: ${rem(4)};
    ${(prop) => (prop.marginBottom ? `margin-bottom: ${rem(prop.marginBottom)} !important` : '')}}

    &.error {
        border-color: ${({ theme }) => theme.colors.danger};
    }
`;

export const Select = styled.select<{ bottom?: number; top?: number }>`
    height: ${rem(45)};
    border: ${rem(12)} solid ${({ theme }) => theme.colors.white};
    outline: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
    width: ${rem(300)};
    color: ${({ theme }) => theme.colors.grey};
    border-radius: ${rem(4)};
    margin-bottom: ${(props) => (props.bottom ? `${rem(props.bottom)}` : 0)};
    margin-top: ${(props) => (props.top ? `${rem(props.top)}` : 0)};
`;

export const Option = styled.option``;

export const Error = styled.span<{ bottom?: number }>`
    color: ${({ theme }) => theme.colors.danger};
    font-size: ${({ theme }) => theme.fontSizes.textSmall};
    position: absolute;
    left: 0;
    bottom: ${(props) => (props.bottom ? `-${rem(props.bottom)}` : `-${rem(14)}`)};
`;

export const CheckboxLabel = styled.span`
    a {
        color: ${({ theme }) => theme.colors.primary};
        text-decoration: none;
    }
`;

export const Agreements = styled.div``;

export const Background = styled.div<{ isActive: boolean; marginTop?: number }>`
    ${(prop) =>
        prop.isActive
            ? `
        display: flex;
        flex-direction: column;
        border: 1px solid ${prop.theme.colors.border};
        border-radius: ${rem(16)};
        padding: ${rem(10)};
        
        @media (min-width: ${breakpoints.sm}px) {
            padding: ${rem(40)};
        }
    `
            : `${prop.marginTop ? `margin-top: ${rem(prop.marginTop)}` : ''}`};

    width: 100%;

    @media (min-width: ${breakpoints.xs}px) {
        width: ${rem(450)};
    }

    input {
        margin: ${rem(10)} auto;
    }
`;

export const GlobalErrorMessage = styled.span`
    color: ${({ theme }) => theme.colors.danger};
    padding-top: ${rem(15)};
    display: block;
`;
